import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export default function PasswordInput({ className = "", ...props }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        className={`${className} pr-12`}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        className="absolute right-1 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full text-muted-foreground"
      >
        {visible ? <EyeSlash size={18} weight="duotone" /> : <Eye size={18} weight="duotone" />}
      </Button>
    </div>
  );
}
